import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';

const LOCAL_STORAGE_KEY = 'notification_permission_asked';

export const useFirstLoginNotification = () => {
  const { user } = useAuth();
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkIfShouldShow = async () => {
      // No mostrar si no hay usuario
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        // Verificar si Notification API está disponible
        if (!('Notification' in window)) {
          setLoading(false);
          return;
        }

        // No mostrar si ya tiene permisos (granted o denied)
        if (Notification.permission !== 'default') {
          setLoading(false);
          return;
        }

        // Verificar localStorage primero (más rápido)
        const askedLocalStorage = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (askedLocalStorage) {
          setLoading(false);
          return;
        }

        // Verificar en Firestore si ya se le preguntó antes
        const userRef = doc(db, 'users', user.uid);
        const userSnap = await getDoc(userRef);
        
        if (userSnap.exists()) {
          const data = userSnap.data();
          
          // Si tiene notificationPermissionAsked = true, no mostrar
          if (data.notificationPermissionAsked === true) {
            localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
            setLoading(false);
            return;
          }
        }

        // Si llegamos aquí, es primera vez -> mostrar modal
        setShouldShowModal(true);
        setLoading(false);
      } catch (error) {
        console.error('Error checking notification permission status:', error);
        setLoading(false);
      }
    };

    checkIfShouldShow();
  }, [user]);

  const markAsAsked = async () => {
    if (!user) return;

    try {
      // Guardar en localStorage
      localStorage.setItem(LOCAL_STORAGE_KEY, 'true');

      // Guardar en Firestore
      const userRef = doc(db, 'users', user.uid);
      await setDoc(userRef, {
        notificationPermissionAsked: true,
        notificationPermissionAskedAt: new Date(),
      }, { merge: true });

      setShouldShowModal(false);
    } catch (error) {
      console.error('Error marking notification permission as asked:', error);
    }
  };

  return {
    shouldShowModal,
    loading,
    markAsAsked,
  };
};
